import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentContainer } from '../../core/content-container/content-container';

@Component({
  selector: 'app-quem-somos',
  imports: [ContentContainer],
  templateUrl: './quem-somos.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuemSomosComponent {}
